/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Document, Page, Image, View } from '@react-pdf/renderer';
import { styles } from './styles';
import { AttestationScolaire } from './index';
import { AssurranceScolaire } from './assuranceScolaireWeb';

export const CpCgScolaire = (props: any) => {
    const {detailContrat} = props; 
    
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                    <Image
                        src={require('../../../../ressources/images/deco_pdf.png')}
                        style={styles.image}
                    />
                    <View style={styles.containerBlock}>
                        <AttestationScolaire detailContrat={detailContrat} />
                    </View>

            </Page>
           { 
            //CP scolaire
            }
            <Page size="A4" style={styles.page}>
                    <AssurranceScolaire detailContrat={detailContrat} />
            </Page>
            {
             //cg rcvp
            }
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-1.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-2.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-3.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-4.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-5.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-6.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-7.png')} style={styles.image}/>
            </Page>
            <Page size="A4" >
                <Image src={require('../../../../ressources/cgCp/Scolaire/cg/CG_SCOLAIRE-8.png')} style={styles.image}/>
        </Page>
        </Document>
    );
}